import { useEffect } from 'react';

/**
 * 该钩子用于监听storage某个key的值的变化
 * @param {function} callback key变化时的回调 该回调函数有两个参数第一个是变化后的值，第二个参数是变化前的值
 * @param {string} key storage的key
 */
export function useStorageChange(
  callback: (newValue: string | null, oldValue?: string | null) => void,
  key?: string
): void {
  useEffect(() => {
    const eventHandler = (event: StorageEvent): void => {
      // 当storage.clear被调用 event.key为null
      if (event.key == null) {
        return callback(event.newValue, event.oldValue);
      }
      // 当storage中某个key的值发生变化
      const isKeyChanged = event.key === key && event.newValue !== event.oldValue;
      if (isKeyChanged) {
        callback(event.newValue, event.oldValue);
      }
    };
    window.addEventListener('storage', eventHandler);
    return (): void => {
      window.removeEventListener('storage', eventHandler);
    };
  }, []);
}
